import { ENABLED_CONFIGURATION_KEY, BRAZE_CONFIGURATIONS } from '../config';

export function useBrazeWebEnv() {
  if (typeof window !== 'undefined' && window?.TEST_RUNNER === 'cypress') {
    return BRAZE_CONFIGURATIONS['test'];
  }
  return BRAZE_CONFIGURATIONS[ENABLED_CONFIGURATION_KEY];
}
